<script lang="ts">
	import Labelled from "@components/form/Labelled.svelte";
	import Select from "@components/form/Select.svelte";
	import type { ComponentProps, Snippet } from "svelte";
	import type { ClassValue, HTMLLabelAttributes } from "svelte/elements";

	type SelectEvent = Event & { currentTarget: EventTarget & HTMLSelectElement };
	type SelectEventHandler = ((event: SelectEvent) => void) | null | undefined;

	const {
		wrapperClass,
		label,
		children,
		oninvalid: _oninvalid,
		onchange: _onchange,
		...rest
	}: ComponentProps<typeof Select> & {
		wrapperClass?: ClassValue;
		children: Snippet;
		label?: HTMLLabelAttributes;
	} = $props();

	const oninvalid = _oninvalid as SelectEventHandler;
	const onchange = _onchange as SelectEventHandler;

	const id = $derived(`${rest.id ?? rest.name ?? ""}-${crypto.randomUUID()}`);

	let validationError = $state("");
</script>

<Labelled {wrapperClass} required={rest.required} label={{ ...label, for: id }} error={validationError}>
	{@render children()}
	{#snippet content()}
		<Select
			class="flex-1"
			{...rest}
			{id}
			oninvalid={(event: SelectEvent): void => {
				validationError = event.currentTarget.validationMessage;
				oninvalid?.(event);
			}}
			onchange={(event: SelectEvent): void => {
				if (event.currentTarget.validity.valid) {
					validationError = "";
				}
				onchange?.(event);
			}}
		/>
	{/snippet}
</Labelled>
